import { createContext } from 'react';

import { ConfirmationDialogOptions } from './types';

export default createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  confirmBase: (_parentId: string, _options: Partial<ConfirmationDialogOptions> = {}): Promise<boolean> => {
    throw new Error('Missing ConfirmationDialogProvider');
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  closeOnParentUnmount: (_parentId: string): void => {
    throw new Error('Missing ConfirmationDialogProvider');
  },
});
